<template>
  <info-field class="mb-3">
    {{ $t('section.personal_data__hint') }}
  </info-field>
</template>

<script>
import InfoField from '@/components/fields/InfoField.vue';

export default {
  name: 'TipForPersonalData',
  components: {
    InfoField,
  },
};
</script>
